//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardBody } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import { calculateDiscountedPrice, getDiscountPercent, areDiscountsEnabled, hasDiscount } from "~/utils/discount";

export default {
  name: "CourseFloatingCard",
  components: { BCard, BCardBody, Icon },
  props: {
    img: String,
    imgAlt: String,
    name: String,
    shortName: String,
    priceUSD: Number,
    pricePesos: Number,
    dateCourse: String,
    language: String,
    level: String,
    duration: String,
    slug: String,
    shortDescription: String,
    graduationCertificate: Boolean,
  },
  computed: {
    discountedPriceUSD() {
      return calculateDiscountedPrice(this.priceUSD, this.shortName);
    },
    discountPercent() {
      return getDiscountPercent(this.shortName);
    },
    shouldShowDiscount() {
      return areDiscountsEnabled() && hasDiscount(this.shortName);
    }
  },
  methods: {
    handleStartCourse() {
      this.$emit("start-course");
    },
  },
};
